import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SharedService } from './shared.services';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MenuService extends SharedService {
  @Output() dataEventEmit = new EventEmitter<any>();
  private rolesUsuarioSubject = new BehaviorSubject<any>([]);
  rolesUsuario$ = this.rolesUsuarioSubject.asObservable();
  constructor(http: HttpClient) {
    super(http);
  }
  actualizarRoles(roles: any) {
    this.rolesUsuarioSubject.next(roles);
  }

}
